import Separator from './separator'

export default Separator